"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getMenu = function getMenu(menus, user) {
  var isTopMenu = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var WorkspacePermissions = user.permissionIds;
  function checkPermission(menu) {
    if (typeof user.roles !== "undefined") {
      if (menu.permissions.length === 0) {
        return true;
      }
      return WorkspacePermissions.some(function (r) {
        return menu.permissions.includes(r);
      });
    }
  }
  if (isTopMenu) {
    if (menus && menus.filter(checkPermission).length > 0) {
      var topmenus = menus.filter(checkPermission);
      var isSameAPP = topmenus.filter(function (tmenu) {
        return tmenu.appId === process.env.REACT_APP_ID;
      });
      if (isSameAPP.length < 1) {
        document.location = topmenus[0].href;
      }
    }
  }
  return menus && menus.filter(checkPermission);
};
var _default = getMenu;
exports["default"] = _default;